export const masterMessage = {
  botMessageList: "Bot Master Message List",
  platformTypeSelect: "Target:",
  groupTypeSelect: "Group type:",
  editMessage: "Edit Message",
  messageList: "Message List",
};
